<template lang="pug">
ValidationProvider(name="Reinigungsfirma" :rules="rules" v-slot="{ errors, valid }")
  b-field(label="Reinigungsfirma" label-position="on-border"
          :type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors")
    b-select(v-model="innerValue")
      option(v-for="cleaner in cleaners" :value="cleaner.id") {{cleaner.company}}
</template>

<script>
export default {
  props: {
    rules: {
      type: [Object, String],
      default: "required"
    },
    value: {
      type: null
    }
  },
  data() {
    return {
      innerValue: ""
    };
  },
  computed: {
    cleaners() {
      return this.$store.state.cleaners.all;
    }
  },
  watch: {
    // Handles internal model changes.
    innerValue(newVal) {
      this.$emit("input", newVal);
    },
    // Handles external model changes.
    value(newVal) {
      this.innerValue = newVal;
    }
  },
  created() {
    if (this.value) {
      this.innerValue = this.value;
    }
  },
  async mounted() {
    await this.$store.dispatch("cleaners/findAll");
  }
};
</script>